import {Injectable} from '@angular/core';
import {FromProviderResolverService} from '@abstract/from-provider-resolver.service';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {SpecialistsProvider} from '@providers/specialists/specialists.provider';

@Injectable()
export class SpecialistsResolverService extends FromProviderResolverService<SpecialistViewInterface[]> {
    constructor(
        provider: SpecialistsProvider,
    ) {
        super(provider);
    }
}
